module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_allWidthsMin.3b49f9f2.tom";